import { render, staticRenderFns } from "./OrmBatchStatistics2.vue?vue&type=template&id=1af8f9fc&scoped=true"
import script from "./OrmBatchStatistics2.vue?vue&type=script&lang=js"
export * from "./OrmBatchStatistics2.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchStatistics2.vue?vue&type=style&index=0&id=1af8f9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8f9fc",
  null
  
)

export default component.exports